import { render, staticRenderFns } from "./ModalNewVenhicleFuelRedesign.vue?vue&type=template&id=624990ae&scoped=true&"
import script from "./ModalNewVenhicleFuelRedesign.vue?vue&type=script&lang=js&"
export * from "./ModalNewVenhicleFuelRedesign.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewVenhicleFuelRedesign.vue?vue&type=style&index=0&id=624990ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624990ae",
  null
  
)

export default component.exports